import React, {useEffect, useMemo} from "react";

import { OrdersFilter } from '../../modules/OrdersFilter';
import { OrdersTable } from '../../modules/OrdersTable';
import {useOrdersUIContext} from "../../../contexts/OrdersUIContext";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import * as actions from "../../../../redux/modules/orders/actions";

export function OrdersContainer() {
  const context = useOrdersUIContext();

  const props = useMemo(() => ({
    queryParams: context.queryParams,
    setQueryParams: context.setQueryParams,
    openOrderDetailDialog: context.openOrderDetailDialog,
    onClick: (_, row) => context.openOrderDetailDialog(row.id),
  }), [context]);

  // Getting curret state of products list from store (Redux)
  const {orderState} = useSelector((state) => ({
    orderState: state.orders,
  }), shallowEqual);
  const {totalCount, orderList, listLoading} = orderState;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.fetchOrders(props.queryParams));
  }, [props.queryParams, dispatch]);

  return (
    <div className="flex-grow-1">
      {/* Start:: OrdersFilter */}
      <div className="mb-10">
        <OrdersFilter />
      </div>
      {/* End:: OrdersFilter */}

      {/* Start:: OrdersTable */}
      <div className="mb-10">
        <OrdersTable
          orderList={orderList}
          totalCount={totalCount}
          listLoading={listLoading}
        />
      </div>
      {/* End:: OrdersTable */}
    </div>
  );
}
